import React from 'react'
import PropTypes from 'prop-types'
import {Field, reduxForm} from 'redux-form'
import FormInput from 'components/FormInput'
import Icon from 'components/Icon'
import isEmail from 'validator/lib/isEmail'
import Button from 'components/Button'

class SignInForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool
  }

  render() {
    const {handleSubmit, invalid, submitting} = this.props

    return (
      <form className='auth-view_form is-login' onSubmit={handleSubmit}>
        <div className='auth-view_title is-single'>Welcome back!</div>
        <Field
          className='auth-view_form-field'
          name='email'
          placeholder='Email'
          disabled={submitting}
          component={FormInput}
        />
        <Field
          className='auth-view_form-field'
          name='password'
          placeholder='Password'
          type='password'
          disabled={submitting}
          component={FormInput}
        />
        <Button disabled={invalid || submitting} color='green' type='submit'>
          Login
          <Icon className='auth-view_form_button_icon' name='arrow-button' size='23px' />
        </Button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'signIn',
  validate: ({email, password}) => {
    const errors = {}

    if (!email) {
      errors.email = 'Email is required'
    } else if (!isEmail(email)) {
      errors.email = 'Incorrect email address'
    }

    if (!password) {
      errors.password = 'Password is required'
    }

    return errors
  }
})(SignInForm)



// WEBPACK FOOTER //
// ./client/views/AuthView/SignInForm.js